/**
 * @file TertiaryNav/constants.js
 * @copyright 2017 CBC/Radio-Canada. All rights reserved.
 * @author Fitore Jaha [fitore.jaha@cbc.ca]
 */

export const HIDE_TERTIARY_NAV = {
    "sports/soccer/worldcup": true,
};
